export const networkTechnologiesConst = {
  path: "/single-programs/network-technologies",
  title: "ФАКУЛЬТЕТ ИТ И ИНЖЕНЕРИИ – СЕТЕВЫЕ ТЕХНОЛОГИИ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Сетевые технологии — фундамент цифровой инфраструктуры</h2>
      <p>
        Сетевые технологии — это область, без которой невозможна работа ни одного современного бизнеса. Программа охватывает всё: от
        проектирования и обслуживания локальных и глобальных сетей до облачных решений, безопасности и автоматизации инфраструктуры.
      </p>
      <p>
        Студенты изучают протоколы передачи данных, администрирование серверов и оборудования, технологии виртуализации, DevOps-подходы и
        взаимодействие с облачными платформами.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Сетевые протоколы и архитектура TCP/IP</li>
        <li>Проектирование и конфигурация сетей</li>
        <li>Маршрутизация и коммутация</li>
        <li>Безопасность сетей (VPN, Firewall, IDS/IPS)</li>
        <li>Облачные технологии и контейнеризация (AWS, Azure, Docker)</li>
        <li>DevOps-инструменты (CI/CD, Ansible, Kubernetes)</li>
        <li>Linux и Windows Server администрирование</li>
        <li>Виртуализация и построение дата-центров</li>
        <li>Поддержка и мониторинг корпоративных сетей</li>
        <li>Подготовка к международной сертификации (Cisco, CompTIA)</li>
      </ul>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Сетевой инженер</li>
        <li>DevOps-специалист</li>
        <li>Системный администратор</li>
        <li>IT-инфраструктурный архитектор</li>
        <li>Специалист по технической поддержке</li>
        <li>Облачный инженер</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€50,000 до €95,000 в год,</strong> в зависимости от уровня сертификации и опыта.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с международным признанием</li>
        <li>Современные лаборатории и удаленный доступ к оборудованию</li>
        <li>Обучение через практику и реальные кейсы</li>
        <li>Преподаватели с опытом в международных IT-проектах</li>
        <li>Подготовка к сертификации Cisco, Linux, AWS</li>
        <li>Гибкий формат: очно или дистанционно</li>
      </ul>
      <p>Сетевые технологии — это профессия, которая всегда в центре цифровых изменений.</p>
      <h2>Как поступить?</h2>
      <p>Поступление — это просто. Приёмная комиссия поможет вам пройти все этапы: от консультации до подачи заявки.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Сетевые технологии — фундамент цифровой инфраструктуры
    Сетевые технологии — это область, без которой невозможна работа ни одного современного бизнеса. Программа охватывает всё: от проектирования и обслуживания локальных и глобальных сетей до облачных решений, безопасности и автоматизации инфраструктуры.
    Студенты изучают протоколы передачи данных, администрирование серверов и оборудования, технологии виртуализации, DevOps-подходы и взаимодействие с облачными платформами.

    Что вы будете изучать?
    • Сетевые протоколы и архитектура TCP/IP
    • Проектирование и конфигурация сетей
    • Маршрутизация и коммутация
    • Безопасность сетей (VPN, Firewall, IDS/IPS)
    • Облачные технологии и контейнеризация (AWS, Azure, Docker)
    • DevOps-инструменты (CI/CD, Ansible, Kubernetes)
    • Linux и Windows Server администрирование
    • Виртуализация и построение дата-центров
    • Поддержка и мониторинг корпоративных сетей
    • Подготовка к международной сертификации (Cisco, CompTIA)

    Кем можно работать после окончания?
    • Сетевой инженер
    • DevOps-специалист
    • Системный администратор
    • IT-инфраструктурный архитектор
    • Специалист по технической поддержке
    • Облачный инженер

    Средний доход в Европе:
    от €50,000 до €95,000 в год, в зависимости от уровня сертификации и опыта.

    Почему выбирают нас?
    • Европейский диплом с международным признанием
    • Современные лаборатории и удаленный доступ к оборудованию
    • Обучение через практику и реальные кейсы
    • Преподаватели с опытом в международных IT-проектах
    • Подготовка к сертификации Cisco, Linux, AWS
    • Гибкий формат: очно или дистанционно

    Сетевые технологии — это профессия, которая всегда в центре цифровых изменений.

    Как поступить?
    Поступление — это просто. Приёмная комиссия поможет вам пройти все этапы: от консультации до подачи заявки.
  `,
};
